/**
 * @summary - Component that Provides Asset Type Code Edit Page
 * @author Yuvasri S
 * @since 2024-05-28
 */
import React, { useState, useEffect } from "react";
import { Box, Grid, Button } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import { useNavigate, useLocation } from "react-router";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";
import CustomDialog from "../commoncomponents/CustomDialog";
import { MasterGraph } from "../../utility/apiURLS";
import {
    getAuthToken,
    getcompanyId,
    getFacilityId,
    getCreatedBy,
    getModifiedBy,
} from "../../utility/tokenUtility";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import PageTitle from "../commoncomponents/PageTitle";

const EditAssetTypeCode = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [service, setService] = useState("");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [classification, setClassification] = useState("");
    const [classificationOptions, setClassificationOptions] = useState([]);
    const [category, setCategory] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [categoryDesc, setCategoryDesc] = useState("");
    const [typecode, setTypeCode] = useState("");
    const [typedescription, setTypeCodeDesc] = useState("");
    const [ppmfrequency, setPpmFrequency] = useState("")
    const [typecodeId, setTypeCodeId] = useState("");
    const [readOnly, setReadOnly] = useState(false);
    const [readOnlyEdit, setReadOnlyEdit] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    //cancel validation
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [errors, setErrors] = useState({
        service: false,
        classification: false,
        category: false,
        typecode: false,
        typedescription: false,
        ppmfrequency: false,
    });

    const [errorMessages, setErrorMessages] = useState({
        service: "",
        classification: "",
        category: "",
        typecode: "",
        typedescription: "",
        ppmfrequency: "",
    });

    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const companyId = getcompanyId("companyId");
    const facilityId = getFacilityId("facilityId");
    const modifiedBy = getModifiedBy("modifiedBy");


    useEffect(() => {
        const fetchInitialData = async () => {
            if (location.state) {
                const {
                    serviceId,
                    serviceName,
                    assetclassification,
                    assetclassificationId,
                    assetcategory,
                    assetcategoryId,
                    assetCategoryDescription,
                    typecode,
                    typeDescription,
                    typecodeId,
                    readOnly,
                    readOnlyEdit,
                    mode,
                    intervalunit,
                    ppmintervaltypeid,
                } = location.state;

                const selectedService = serviceOptions.find(
                    (option) => option.label === serviceName
                );
                const selectedClassification = classificationOptions.find(
                    (option) => option.label === assetclassification
                );
                const selectedCategory = categoryOptions.find(
                    (option) => option.label === assetcategory
                );

                setService(
                    selectedService
                        ? selectedService
                        : { value: serviceName, label: serviceName, id: serviceId }
                );
                setClassification(
                    selectedClassification
                        ? selectedClassification
                        : {
                            value: assetclassification,
                            label: assetclassification,
                            id: assetclassificationId,
                        }
                );
                setCategory(
                    selectedCategory
                        ? selectedCategory
                        : {
                            value: assetcategory,
                            label: assetcategory,
                            id: assetcategoryId,
                        }
                );
                setCategoryDesc(assetCategoryDescription);
                setTypeCode(typecode);
                setTypeCodeDesc(typeDescription);
                setTypeCodeId(typecodeId);
                setPpmFrequency(intervalunit);
                setReadOnlyEdit(!!readOnlyEdit);
                setIsEdit(true);
            }
        };
        fetchInitialData();
    }, [location.state]);

    const handleSubmit = (e) => {
        e.preventDefault();

        let formIsValid = true;
        const newErrors = {

            typecode: false,
            typedescription: false,
            ppmfrequency: false,
        };
        const newErrorMessages = {

            typecode: "",
            typedescription: "",
            ppmfrequency: "",
        };

        if (!typecode) {
            formIsValid = false;
            newErrors.typecode = true;
            newErrorMessages.typecode = "Type Code is required";
        } else if (typecode.startsWith(" ")) {
            formIsValid = false;
            newErrors.typecode = true;
            newErrorMessages.typecode = "Space not allowed at the beginning";
        } else if (typecode.includes("  ")) {
            formIsValid = false;
            newErrors.typecode = true;
            newErrorMessages.typecode = "Double Space not allowed";
        } else if (!/^[a-zA-Z0-9 /-]*$/.test(typecode)) {
            formIsValid = false;
            newErrors.typecode = true;
            newErrorMessages.typecode = "Invalid Characters in Type Code";
        }

        if (!ppmfrequency) {
            formIsValid = false;
            newErrors.ppmfrequency = true;
            newErrorMessages.ppmfrequency = "Standard PPM Frequency";
        } else if (ppmfrequency.startsWith(" ")) {
            formIsValid = false;
            newErrors.ppmfrequency = true;
            newErrorMessages.ppmfrequency = "Space not allowed at the beginning";
        } else if (ppmfrequency.includes("  ")) {
            formIsValid = false;
            newErrors.ppmfrequency = true;
            newErrorMessages.ppmfrequency = "Double Space not allowed";
        } else if (!/^[a-zA-Z0-9 /-]*$/.test(ppmfrequency)) {
            formIsValid = false;
            newErrors.ppmfrequency = true;
            newErrorMessages.ppmfrequency = "Only Numbers are allowed";
        }

        if (!typedescription) {
            formIsValid = false;
            newErrors.typedescription = true;
            newErrorMessages.typedescription = "Type Code Description is required";
        } else if (typedescription.startsWith(" ")) {
            formIsValid = false;
            newErrors.typedescription = true;
            newErrorMessages.typedescription = "Space not allowed at the beginning";
        } else if (typedescription.includes("  ")) {
            formIsValid = false;
            newErrors.typedescription = true;
            newErrorMessages.typedescription = "Double Space not allowed";
        } else if (!/^[a-zA-Z0-9,!@#$%&*()_\- .]*$/.test(typedescription)) {
            formIsValid = false;
            newErrors.typedescription = true;
            newErrorMessages.typedescription =
                "Invalid Characters in Type Code Description";
        }

        setErrors(newErrors);
        setErrorMessages(newErrorMessages);

        if (formIsValid) {
            handleSave();
            setHasUnsavedChanges(false);
        }
    };

    const handleAtCodeChange = (newValue) => {
        setHasUnsavedChanges(true);
        setTypeCode(newValue);

        const regex = /^[a-zA-Z0-9 /-]*$/;

        if (!regex.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, typecode: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typecode: "Invalid characters in Type Code",
            }));
        } else if (newValue.startsWith(" ")) {
            setErrors((prevErrors) => ({ ...prevErrors, typecode: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typecode: "Space not allowed at the beginning",
            }));
        } else if (newValue.includes("  ")) {
            setErrors((prevErrors) => ({ ...prevErrors, typecode: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typecode: "Double Space not allowed",
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, typecode: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, typecode: "" }));
        }
    };

    const handlefrequencyChange = (newValue) => {
        setHasUnsavedChanges(true);
        setPpmFrequency(newValue);

        const regex = /^[0-9]*$/;

        if (!regex.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, ppmfrequency: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                ppmfrequency: "Only Numbers are allowed",
            }));
        } else if (newValue.startsWith(" ")) {
            setErrors((prevErrors) => ({ ...prevErrors, ppmfrequency: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                ppmfrequency: "Space not allowed at the beginning",
            }));
        } else if (newValue.includes("  ")) {
            setErrors((prevErrors) => ({ ...prevErrors, ppmfrequency: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                ppmfrequency: "Double Space not allowed",
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, ppmfrequency: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, ppmfrequency: "" }));
        }
    };


    const handleAtDescChange = (newValue) => {
        setHasUnsavedChanges(true);
        setTypeCodeDesc(newValue);

        const regex = /^[a-zA-Z0-9,!@#$%&*()_\- .]*$/;

        if (!regex.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, typedescription: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typedescription: "Invalid characters in Type Code Description",
            }));
        } else if (newValue.startsWith(" ")) {
            setErrors((prevErrors) => ({ ...prevErrors, typedescription: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typedescription: "Space not allowed at the beginning",
            }));
        } else if (newValue.includes("  ")) {
            setErrors((prevErrors) => ({ ...prevErrors, typedescription: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typedescription: "Double Space not allowed",
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, typedescription: false }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                typedescription: "",
            }));
        }
    };

    const handleSave = async () => {
        try {
            if (isEdit) {
                const {
                    serviceId,
                    serviceName,
                    assetclassification,
                    assetclassificationId,
                    assetcategory,
                    assetcategoryId,
                    assetCategoryDescription,
                } = location.state;
                const payload = {
                    typecode,
                    typedescription,
                    id: typecodeId,
                    masservicedetailsId: serviceId,
                    masassetcategoryId: assetcategoryId,

                    // masservicedetails: {
                    //     service: serviceName,
                    //     servicedesc: service.value,
                    //     id: serviceId,
                    //     masassetcategories: [],
                    //     masassettypecodes: [],
                    //     maslicensecertheaders: [],
                    //     mascalibrationcertheaders: [],
                    //     maslicensetypecodedetails: [],
                    // },
                    // masassetcategory: {
                    //     assetcategory: assetcategory,
                    //     assetcategorydesc: assetCategoryDescription,
                    //     id: assetcategoryId,
                    //     companyid: companyId,
                    //     masassettypecodes: [],
                    // },
                    masassetclassification: {
                        assetclassification: assetclassification,
                        id: assetclassificationId,
                        isvisible: true,
                        masassettypecodes: [],
                    },
                    isppmrequired: true,
                    modifiedby: modifiedBy,
                    masimscompanyitemdetails: [],
                    ppmintervaltypeid: (ppmfrequency === "" || ppmfrequency === 0 || ppmfrequency === null) ? null : 2,
                    intervalunit: ppmfrequency || null,
                    isimagingequipment: (ppmfrequency === "" || ppmfrequency === 0 || ppmfrequency === null) ? null : 1,
                };


                await axios.put(
                    `${MasterGraph}/api/masassettypecodes/${typecodeId}`,
                    payload,
                    config
                );
            }
            setDialogOpen(true);
        } catch (error) {
            console.error("Error saving data:", error);
            if (error.response && error.response.status === 400) {
                setErrorMessage("Asset Type Code Already Exists");
            } else {
                setErrorMessage(
                    "An unexpected error occurred. Please try again later."
                );
            }
            setErrorDialogOpen(true);
        }
    };

    const handleCancel = () => {
        if (hasUnsavedChanges) {
            setCancelDialogOpen(true);
        }
        else {
            navigate(-1, { replace: true });
        }
    };

    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate(-1, { replace: true });
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleCategoryChange = () => {

    }

    return (
        <>
            <PageTitle
                title={"Edit Asset Type Code"}
            />

            <DefaultCard sx={{ height: "100%" }}>
                <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                    <Grid container gap={3}>
                        <Grid item xs={6} md={3.8}>
                            <CustomSelectInput
                                id="service-label"
                                label="Service"
                                value={service}
                                options={serviceOptions}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                disabled={readOnlyEdit}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomSelectInput
                                maxlength={10}
                                id="classification-label"
                                label="Asset Classification"
                                value={classification}
                                options={classificationOptions}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                disabled={readOnlyEdit}
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextFieldWithSearch
                                label="Asset Category"
                                id="asset-category"
                                value={category}
                                options={categoryOptions}
                                onChange={handleCategoryChange}
                                disabled={readOnlyEdit}
                            />
                        </Grid>

                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={225}
                                label="Asset Category Description"
                                id="category-desc"
                                value={categoryDesc}
                                disabled={true}
                                placeholder=""
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={10}
                                label="Type Code"
                                id="type-code"
                                value={typecode}
                                onChange={handleAtCodeChange}
                                isMandatoryField={true}
                                error={errors.typecode}
                                errorMessage={errorMessages.typecode}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={3.8}>
                            <CustomTextField
                                maxlength={255}
                                label="Type Code Description"
                                id="type-code-description"
                                value={typedescription}
                                onChange={handleAtDescChange}
                                isMandatoryField={true}
                                error={errors.typedescription}
                                errorMessage={errorMessages.typedescription}
                            />
                        </Grid>
                        {location?.state?.serviceName === "BEMS" && (
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    maxlength={10}
                                    label="Standard PPM Frequency"
                                    id="standard-ppm-frequency"
                                    value={ppmfrequency}
                                    onChange={handlefrequencyChange}
                                    error={errors.ppmfrequency}
                                    errorMessage={errorMessages.ppmfrequency}
                                    disabled={localStorage.getItem("roleName") === "CorporateAdmin" ? false : true}
                                />
                            </Grid>
                        )}
                    </Grid>
                </form>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: { xs: "center", md: "end" },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button variant="contained" color="primary" sx={{ m: 1 }} onClick={handleSubmit}>
                            Update
                        </Button>
                        <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                            Back
                        </Button>
                    </Box>
                </Box>
            </DefaultCard>

            <CustomDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                onConfirm={handleDialogClose}
                title="Success"
                confirmBtn="Ok"
                content="Data updated successfully."
            />

            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                content="Record(s) not Saved/Updated. Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />

            <CustomDialog
                open={errorDialogOpen}
                onClose={() => setErrorDialogOpen(false)}
                onConfirm={() => setErrorDialogOpen(false)}
                confirmBtn="Ok"
                content={errorMessage}
            />
        </>
    );
};

export default EditAssetTypeCode;
